import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY } from './common';

const routes = [
    {
        matchRegex: '/GoodsReceivedNotes/Detail/:id',
        name: 'Goods Received Notes - Detail',
        slots: [
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
            SLOT_KEY.SLOT_SCRIPTS,
        ],
        image: PreviewDetailImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'grn-items-table', label: 'GRN Items Table' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                {
                    key: 'MARKETPLACE_EVENT_ADD_COLUMN_SETTING_TO_TABLE',
                    label: 'Add Column to Table Setting',
                },
                {
                    key: 'MARKETPLACE_EVENT_FETCH_LIST_SUCCESS',
                    label: 'Trigger Fetch List Successfully',
                },
                {
                    key: 'MARKETPLACE_EVENT_VALIDATE_GRN_DELIVERY_QTY',
                    label: 'Validate GRN Delivery Quantity',
                },
                {
                    key: 'MARKETPLACE_EVENT_DELETE_GRN_SUCCESS',
                    label: 'After Delete GRN Success',
                },
            ],
        },
    },
    {
        matchRegex: '/GoodsReceivedNotes/Create',
        name: 'Goods Received Notes - Create',
        slots: [
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN,
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN]: [
                { key: 'table-grn-po-items-header', label: 'Table "GRN PO Items" header' },
                { key: 'table-grn-po-items-body', label: 'Table "GRN PO Items" body' }
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                {
                    key: 'MARKETPLACE_EVENT_VALIDATE_GRN_DELIVERY_QTY',
                    label: 'Validate GRN Delivery Quantity',
                },
                {
                    key: 'MARKETPLACE_EVENT_EXTEND_VALIDATION_RULES',
                    label: 'Extend Create GRN Validation Rules',
                },
            ],
        },
    },
]

export default routes;